import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Finance } from 'financejs';
import { DataService } from '../data.service';
import { ValidationService } from '../validation.service'
import * as Chart from 'chart.js';
const finance = new Finance();
declare var $: any;
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { CityAnnexureData, CityAnnexureDataMap } from './annexure-market-data';
@Component({
  selector: 'app-calculatedirr',
  templateUrl: './calculatedirr.component.html',
  styleUrls: ['./calculatedirr.component.css']
})
export class CalculatedirrComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('contentToConvert') content: ElementRef;
  calcData: any;
  investedTenure: number;
  TenureWisePropertyData: any = [];
  allCahsflow: any = [];
  allCashFlowInHomeCurrency: any = [];
  IrrInGBP: number;
  IrrInHomeCurrency: number;
  homecurrency: number;
  Initialhomecurrency: number;
  yearlabel: any = [];
  yearlyGBPIRR: any = [];
  yearlyHomeCurrencyIRR: any = [];
  yearlyGBPInHomeCurrency: any = [];
  yearlyPropertyValueInGBP: any = [];
  yearlyPropertyValueInHomeCurrency: any = [];
  MapLoad = true;
  lat: number = 0;
  long: number = 0;
  RentalIncome = 0;
  TotalReturnOfInvestment = 0;
  EquityCapital = 0;
  wealthMultiple = 0;
  returnOnEquity = 0;
  benchMax = 20;
  capitalAppreciation = 0;
  fxAppreciation = 0;
  graphInitialInvestmentInHomeCurrency = 0;
  RentalIncomeGBP = 0;
  capitalAppreciationGBP = 0;
  TotalReturnInGBP = 0;
  homecurrencyText: string;
  loadingPrintbtn = false;
  loadingDownloadbtn = false;
  loadingSharebtn = false;
  today = new Date();
  selectedCountry: string = '';
  countryList: string[] = ['India', 'USA', 'Hong Kong', 'UAE', 'Europe', 'Nigeria', 'Bangladesh', 'Pakistan'];
  irrChart: any = null;
  pieChart: any = null;
  gbpPieChart: any = null;
  private resizeTimer: any = null;
  private _resizeHandler = () => {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      [this.irrChart, this.pieChart, this.gbpPieChart].forEach(c => { if (c) c.resize(); });
    }, 150);
  };
  annexureData: CityAnnexureData = this.getDefaultAnnexureData();

  private resolveAnnexureCityKey(rawCity: string): string {
    const city = (rawCity || '').trim().toLowerCase();
    if (city.includes('manchester')) return 'Manchester';
    if (city.includes('liverpool')) return 'Liverpool';
    if (city.includes('birmingham')) return 'Birmingham';
    if (city.includes('london')) return 'London';
    return 'Manchester';
  }

  isComparableSelected(cityLabel: string): boolean {
    const selected = (this.calcData?.City || '').trim().toLowerCase();
    const rowCity = (cityLabel || '').split('(')[0].trim().toLowerCase();
    return !!selected && rowCity.includes(selected);
  }

  // Comprehensive currency symbol map
  currencySymbolMap: any = {
    'AFN': '؋', 'ALL': 'L', 'AMD': '֏', 'ANG': 'ƒ', 'AOA': 'Kz', 'ARS': '$',
    'AUD': 'A$', 'AWG': 'ƒ', 'AZN': '₼', 'BAM': 'KM', 'BBD': 'Bds$', 'BDT': '৳',
    'BGN': 'лв', 'BHD': 'BD', 'BIF': 'Fr', 'BMD': '$', 'BND': '$', 'BOB': 'Bs.',
    'BRL': 'R$', 'BSD': '$', 'BTN': 'Nu', 'BWP': 'P', 'BYN': 'Br', 'BZD': 'BZ$',
    'CAD': 'C$', 'CHF': 'CHF', 'CLP': '$', 'CNY': '¥', 'COP': '$', 'CZK': 'Kč',
    'DKK': 'kr', 'DOP': 'RD$', 'DZD': 'دج', 'EGP': '£', 'EUR': '€', 'GBP': '£',
    'GHS': 'GH₵', 'HKD': 'HK$', 'HUF': 'Ft', 'IDR': 'Rp', 'ILS': '₪', 'INR': '₹',
    'IQD': 'ع.د', 'JPY': '¥', 'KES': 'KSh', 'KRW': '₩', 'KWD': 'KD', 'KZT': '₸',
    'LKR': 'Rs', 'MAD': 'MAD', 'MXN': '$', 'MYR': 'RM', 'NGN': '₦', 'NOK': 'kr',
    'NPR': 'Rs', 'NZD': 'NZ$', 'OMR': 'ر.ع.', 'PHP': '₱', 'PKR': '₨', 'PLN': 'zł',
    'QAR': 'ر.ق', 'RON': 'lei', 'RUB': '₽', 'SAR': '﷼', 'SEK': 'kr', 'SGD': 'S$',
    'THB': '฿', 'TRY': '₺', 'TWD': 'NT$', 'UAH': '₴', 'USD': '$', 'UZS': 'сўм',
    'VND': '₫', 'XAF': 'FCFA', 'ZAR': 'R', 'ZMW': 'ZK',
    'AED': 'AED'
  };

  getCurrencySymbol(code: string): string {
    if (!code) return '';
    return this.currencySymbolMap[code.toUpperCase()] || code;
  }

  formatCurrency(value: number, currencyCode: string): string {
    if (value === null || value === undefined || isNaN(value)) return '0';
    const sym = this.getCurrencySymbol(currencyCode);
    const abs = Math.abs(value);
    let formatted: string;
    if (currencyCode === 'INR') {
      if (abs >= 1e7) {
        formatted = (abs / 1e7).toFixed(2).replace(/\.?0+$/, '') + ' Cr';
      } else if (abs >= 1e5) {
        formatted = (abs / 1e5).toFixed(2).replace(/\.?0+$/, '') + ' L';
      } else {
        formatted = Math.round(abs).toLocaleString('en-IN');
      }
    } else if (abs >= 1e9) {
      formatted = (abs / 1e9).toFixed(2).replace(/\.?0+$/, '') + 'B';
    } else if (abs >= 1e6) {
      formatted = (abs / 1e6).toFixed(2).replace(/\.?0+$/, '') + 'M';
    } else {
      formatted = Math.round(abs).toLocaleString('en-US');
    }
    return (value < 0 ? '-' : '') + sym + formatted;
  }

  formatCurrencyFull(value: number, currencyCode: string): string {
    if (value === null || value === undefined || isNaN(value)) return '0';
    const sym = this.getCurrencySymbol(currencyCode);
    const abs = Math.abs(value);
    const formatted =
      currencyCode === 'INR'
        ? Math.round(abs).toLocaleString('en-IN')
        : Math.round(abs).toLocaleString('en-US');
    return (value < 0 ? '-' : '') + sym + formatted;
  }

  // Approximate GBP → currency rates and typical annual FX growth vs GBP
  countryFxMap: any = {
    'India':      { rate: 107,  fxGrowth: 2.5,  currency: 'INR' },
    'USA':        { rate: 1.27, fxGrowth: 0.5,  currency: 'USD' },
    'Hong Kong':  { rate: 9.88, fxGrowth: 0.3,  currency: 'HKD' },
    'UAE':        { rate: 4.67, fxGrowth: 0.4,  currency: 'AED' },
    'Europe':     { rate: 1.17, fxGrowth: 0.8,  currency: 'EUR' },
    'Nigeria':    { rate: 2100, fxGrowth: 8.0,  currency: 'NGN' },
    'Bangladesh': { rate: 140,  fxGrowth: 3.5,  currency: 'BDT' },
    'Pakistan':   { rate: 355,  fxGrowth: 7.0,  currency: 'PKR' }
  };
  //lineChartData: ChartDataSets[];
  constructor(private router: Router, private dataService: DataService, public validation: ValidationService, private http: HttpClient) {
    this.calcData = JSON.parse(localStorage.getItem("calcData"));
    if (!this.calcData.reportSavedOnServer)
      this.calcData.reportSavedOnServer = false;
    localStorage.setItem("calcData", JSON.stringify(this.calcData));
    this.calcData.loanOriginationFee = this.dataService.EmptyNullOrUndefined(this.calcData.loanOriginationFee) ? 0 : this.calcData.loanOriginationFee;
    this.investedTenure = parseInt(this.calcData.investedTenure);
    this.homecurrency = parseFloat(parseFloat(this.calcData.homecurrency).toFixed(4));
    this.Initialhomecurrency = parseFloat(parseFloat(this.calcData.homecurrency).toFixed(4));
    // localStorage.clear();
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.lat)) {
      this.lat = this.calcData.lat;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.long)) {
      this.long = this.calcData.long;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.homecurrencyText)) {
      this.homecurrencyText = this.calcData.homecurrencyText;
    }
  }
  ngAfterViewInit(): void {
    const ctx = $('#canvas')[0].getContext('2d');
    const isMobile = $(window).width() <= 960;

    // Gradient fills for trajectory chart (reference design)
    const gbpGradient = ctx.createLinearGradient(0, 0, 0, 360);
    gbpGradient.addColorStop(0, 'rgba(74,90,133,0.18)');
    gbpGradient.addColorStop(1, 'rgba(74,90,133,0)');
    const hcGradient = ctx.createLinearGradient(0, 0, 0, 360);
    hcGradient.addColorStop(0, 'rgba(35,177,75,0.20)');
    hcGradient.addColorStop(1, 'rgba(35,177,75,0)');

    this.irrChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.yearlabel,
        datasets: [{
          label: 'GBP IRR',
          borderColor: '#4a5a85',
          backgroundColor: gbpGradient,
          pointBorderColor: '#ffffff',
          pointBackgroundColor: '#4a5a85',
          pointHoverBackgroundColor: '#4a5a85',
          pointHoverBorderColor: '#ffffff',
          pointRadius: 4,
          pointBorderWidth: 2,
          fill: true,
          lineTension: 0.32,
          borderWidth: 2.5,
          borderCapStyle: 'round',
          data: this.yearlyGBPIRR
        }, ...(this.calcData?.ForeignBuyer === '1' ? [{
          label: this.homecurrencyText + ' IRR',
          borderColor: '#23B14B',
          backgroundColor: hcGradient,
          pointBorderColor: '#ffffff',
          pointBackgroundColor: '#23B14B',
          pointHoverBackgroundColor: '#23B14B',
          pointHoverBorderColor: '#ffffff',
          pointRadius: 4,
          pointBorderWidth: 2,
          fill: true,
          lineTension: 0.32,
          borderWidth: 2.5,
          borderCapStyle: 'round' as 'round',
          data: this.yearlyHomeCurrencyIRR
        }] : [])]
      },
      options: {
        legend: { display: false },
        responsive: true,
        maintainAspectRatio: false,
        title: { display: false },
        scales: {
          xAxes: [{
            display: true,
            gridLines: { display: false },
            scaleLabel: { display: false },
            ticks: { fontColor: 'rgba(51,58,68,0.4)', fontSize: isMobile ? 8 : 11, padding: 8 }
          }],
          yAxes: [{
            display: true,
            gridLines: { color: 'rgba(19,33,71,0.08)', zeroLineColor: 'rgba(19,33,71,0.12)', drawTicks: false },
            scaleLabel: { display: false },
            ticks: { fontColor: 'rgba(51,58,68,0.4)', fontSize: isMobile ? 8 : 11, callback: (v) => v + '%', padding: 8 }
          }]
        },
        tooltips: {
          backgroundColor: '#132147',
          titleFontColor: '#fff',
          bodyFontColor: 'rgba(255,255,255,0.9)',
          cornerRadius: 8,
          borderColor: 'rgba(255,255,255,0.08)',
          borderWidth: 1,
          callbacks: { label: (item) => ' ' + item.yLabel + '%' }
        }
      }
    });






    //second dummy graph

    // const ctx2 = $('#canvas2')[0].getContext('2d');
    // const gradientStroke2 = ctx2.createLinearGradient(500, 0, 100, 0);
    // gradientStroke2.addColorStop(0, '#1d1751');
    // gradientStroke2.addColorStop(1, '#f7f7f7');
    // const gradientStroke3 = ctx2.createLinearGradient(500, 0, 100, 0);
    // gradientStroke3.addColorStop(0, '#1aaf4b');
    // gradientStroke3.addColorStop(1, '#f7f7f7');
    // var myChart = new Chart(ctx2, {
    //   type: 'line',
    //   data: {
    //     labels: this.yearlabel,
    //     datasets: [{
    //       label: 'GBP',
    //       borderColor: gradientStroke,
    //       pointBorderColor: gradientStroke,
    //       pointBackgroundColor: gradientStroke,
    //       pointHoverBackgroundColor: gradientStroke,
    //       pointHoverBorderColor: gradientStroke,
    //       pointRadius: 0,
    //       fill: false,
    //       borderWidth: 9,
    //       borderCapStyle: 'round',
    //       data: this.yearlyPropertyValueInGBP,
    //     }, {
    //       label: this.homecurrencyText,
    //       borderColor: gradientStroke1,
    //       pointBorderColor: gradientStroke1,
    //       pointBackgroundColor: gradientStroke1,
    //       pointHoverBackgroundColor: gradientStroke1,
    //       pointHoverBorderColor: gradientStroke1,
    //       pointRadius: 0,
    //       fill: false,
    //       borderWidth: 9,
    //       borderCapStyle: 'round',
    //       data: this.yearlyPropertyValueInHomeCurrency,
    //     }]
    //   },
    //   options: {
    //     legend: {
    //       display: true
    //     },
    //     responsive: true,
    //     title: {
    //       display: false,
    //       text: 'Yearly IRR (Internal Rate of Return)'
    //     },
    //     scales: {
    //       xAxes: [{
    //         display: true,
    //         scaleLabel: {
    //           display: true,
    //           labelString: 'Year'
    //         },
    //       }],
    //       yAxes: [{
    //         display: true,
    //         scaleLabel: {
    //         display: true,
    //         labelString: 'Percentage'
    //       }
    //       }]
    //     }
    //   }
    // });


    // Plugin: center text + outer callout lines with percentages
    const doughnutPlugin = {
      afterDatasetsDraw: function(chart: any) {
        if (chart.config.type !== 'doughnut') return;
        const ctx2 = chart.ctx;
        const lineExtend = 10;
        const tickLen = 8;
        const pctSize = 14;
        chart.data.datasets.forEach(function(dataset: any, i: number) {
          const meta = chart.getDatasetMeta(i);
          if (meta.hidden) return;
          const total = dataset.data.reduce((a: number, v: number) => a + v, 0);
          meta.data.forEach(function(arc: any, index: number) {
            const val = dataset.data[index];
            if (!val || total === 0 || (val / total) < 0.04) return;
            const pct = ((val / total) * 100).toFixed(1) + '%';
            const model = arc._model || arc;
            const midAngle = model.startAngle + (model.endAngle - model.startAngle) / 2;
            const outerR = model.outerRadius;
            const cx = model.x;
            const cy = model.y;
            const x1 = cx + Math.cos(midAngle) * outerR;
            const y1 = cy + Math.sin(midAngle) * outerR;
            const x2 = cx + Math.cos(midAngle) * (outerR + lineExtend);
            const y2 = cy + Math.sin(midAngle) * (outerR + lineExtend);
            const isRight = Math.cos(midAngle) >= 0;
            const x3 = isRight ? x2 + tickLen : x2 - tickLen;
            const y3 = y2;
            ctx2.save();
            ctx2.strokeStyle = 'rgba(19,33,71,0.35)';
            ctx2.lineWidth = 1;
            ctx2.lineCap = 'round';
            ctx2.beginPath();
            ctx2.moveTo(x1, y1);
            ctx2.lineTo(x2, y2);
            ctx2.lineTo(x3, y3);
            ctx2.stroke();
            ctx2.font = `600 ${pctSize}px Inter, sans-serif`;
            ctx2.fillStyle = '#132147';
            ctx2.textAlign = isRight ? 'left' : 'right';
            ctx2.textBaseline = 'middle';
            ctx2.fillText(pct, x3 + (isRight ? 4 : -4), y3);
            ctx2.restore();
          });
        });
      }
    };

    const ctxpie = $('#can')[0].getContext('2d');
    const fxGrowth = this.TotalReturnOfInvestment - this.RentalIncome - this.capitalAppreciation;
    const isSmallScreen = window.innerWidth <= 810;
    const chartPadding = isSmallScreen
      ? { top: 65, right: 65, bottom: 65, left: 65 }
      : { top: 80, right: 80, bottom: 80, left: 80 };
    this.pieChart = new Chart(ctxpie, {
      type: 'doughnut',
      data: {
        labels: ['Capital Growth', 'FX Appreciation', 'Net Rental Income'],
        datasets: [{
          backgroundColor: ['#132147', '#4a5a85', '#8a99b8'],
          borderColor: '#ffffff',
          borderWidth: 3,
          hoverBorderWidth: 3,
          hoverOffset: 8,
          data: [
            Math.max(this.capitalAppreciation, 0),
            Math.max(fxGrowth, 0),
            Math.max(this.RentalIncome, 0)
          ]
        }]
      },
      plugins: [doughnutPlugin],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 68,
        legend: { display: false },
        layout: { padding: { top: 30, right: 70, bottom: 30, left: 70 } },
        animation: { animateRotate: true, animateScale: false, duration: 900 },
        tooltips: {
          backgroundColor: '#132147',
          titleFontColor: '#fff',
          bodyFontColor: 'rgba(255,255,255,0.9)',
          cornerRadius: 8,
          borderColor: 'rgba(255,255,255,0.08)',
          borderWidth: 1,
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const total = dataset.data.reduce((acc: number, val: number) => acc + val, 0);
              const current = dataset.data[tooltipItem.index];
              const pct = total > 0 ? ((current / total) * 100).toFixed(1) : '0.0';
              return ' ' + data.labels[tooltipItem.index] + ': ' + pct + '%';
            }
          }
        }
      }
    } as any);

    // GBP donut chart
    const ctxpieGBP = $('#can-gbp')[0] ? $('#can-gbp')[0].getContext('2d') : null;
    if (ctxpieGBP) {
      this.gbpPieChart = new Chart(ctxpieGBP, {
        type: 'doughnut',
        data: {
          labels: ['Capital Growth', 'Net Rental Income'],
          datasets: [{
            backgroundColor: ['#132147', '#8a99b8'],
            borderColor: '#ffffff',
            borderWidth: 3,
            hoverBorderWidth: 3,
            hoverOffset: 8,
            data: [
              Math.max(this.capitalAppreciationGBP, 0),
              Math.max(this.RentalIncomeGBP, 0)
            ]
          }]
        },
        plugins: [doughnutPlugin],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 68,
          legend: { display: false },
          layout: { padding: { top: 30, right: 70, bottom: 30, left: 70 } },
          animation: { animateRotate: true, animateScale: false, duration: 900 },
          tooltips: {
            backgroundColor: '#132147',
            titleFontColor: '#fff',
            bodyFontColor: 'rgba(255,255,255,0.9)',
            cornerRadius: 8,
            borderColor: 'rgba(255,255,255,0.08)',
            borderWidth: 1,
            callbacks: {
              label: function(tooltipItem: any, data: any) {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const total = dataset.data.reduce((acc: number, val: number) => acc + val, 0);
                const current = dataset.data[tooltipItem.index];
                const pct = total > 0 ? ((current / total) * 100).toFixed(1) : '0.0';
                return ' ' + data.labels[tooltipItem.index] + ': ' + pct + '%';
              }
            }
          }
        }
      } as any);
    }


    // §04 Benchmark chart
    const benchCanvas = document.getElementById('benchCanvas') as HTMLCanvasElement;
    if (benchCanvas) {
      const ctxB = benchCanvas.getContext('2d');
      const isINR = this.homecurrencyText === 'INR';
      const isForeign = this.calcData?.ForeignBuyer === '1';
      const isMobileB = window.innerWidth < 600;

      const benchLabels: string[] = [];
      const benchData: number[] = [];
      if (isINR) {
        benchLabels.push(
          isMobileB ? `This Prop.` : `This Property (${this.homecurrencyText})`,
          isMobileB ? 'BSE Sensex' : 'BSE Sensex (10yr avg)',
          isMobileB ? 'India RE' : 'Indian Real Estate',
          isMobileB ? 'NRI FD' : 'NRI Fixed Deposit',
          isMobileB ? 'Bank FD' : 'Bank FD (India)'
        );
        benchData.push(this.IrrInHomeCurrency, 12.4, 8.5, 7.5, 7.0);
      } else {
        benchLabels.push(
          isMobileB ? `This Prop.` : `This Property (${this.homecurrencyText})`,
          isMobileB ? 'FTSE 100' : 'FTSE 100 (10yr avg)'
        );
        benchData.push(this.IrrInHomeCurrency, 7.2);
        if (isForeign) { benchLabels.push(isMobileB ? 'UK RE' : 'UK Real Estate (avg)'); benchData.push(5.5); }
        benchLabels.push(isMobileB ? 'Gov Gilts' : 'UK Government Gilts', isMobileB ? 'Cash ISA' : 'UK Cash ISA');
        benchData.push(3.5, 2.8);
      }
      const benchColors: string[] = ['#23B14B'];
      for (let bi = 1; bi < benchLabels.length; bi++) { benchColors.push('#4a5a85'); }
      const xMax = Math.ceil(this.IrrInHomeCurrency * 2) / 2;

      const benchRoundedPlugin = {
        afterDatasetsDraw(chart: any) {
          const ctx2 = chart.ctx;
          chart.data.datasets.forEach((dataset: any, dsIdx: number) => {
            const meta = chart.getDatasetMeta(dsIdx);
            meta.data.forEach((bar: any, barIdx: number) => {
              const vm = bar._view;
              if (!vm) return;
              const left = Math.min(vm.x, vm.base);
              const w = Math.abs(vm.x - vm.base);
              if (w < 2) return;
              const h = vm.height;
              const top = vm.y - h / 2;
              const bgColor = Array.isArray(dataset.backgroundColor) ? dataset.backgroundColor[barIdx] : dataset.backgroundColor;
              if (!bgColor || bgColor === 'rgba(0,0,0,0)') return;
              const r = Math.min(6, w / 2, h / 2);
              ctx2.save();
              ctx2.fillStyle = '#ffffff';
              ctx2.fillRect(left, top, w, h);
              ctx2.fillStyle = bgColor;
              ctx2.beginPath();
              ctx2.moveTo(left + r, top);
              ctx2.lineTo(left + w - r, top);
              ctx2.quadraticCurveTo(left + w, top, left + w, top + r);
              ctx2.lineTo(left + w, top + h - r);
              ctx2.quadraticCurveTo(left + w, top + h, left + w - r, top + h);
              ctx2.lineTo(left + r, top + h);
              ctx2.quadraticCurveTo(left, top + h, left, top + h - r);
              ctx2.lineTo(left, top + r);
              ctx2.quadraticCurveTo(left, top, left + r, top);
              ctx2.closePath();
              ctx2.fill();
              ctx2.restore();
            });
          });
        }
      };

      new (Chart as any)(ctxB, {
        type: 'horizontalBar',
        plugins: [benchRoundedPlugin],
        data: {
          labels: benchLabels,
          datasets: [{
            data: benchData,
            backgroundColor: benchColors,
            barPercentage: 0.55,
            borderSkipped: false,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            xAxes: [{
              gridLines: { color: 'rgba(19,33,71,0.08)', zeroLineColor: 'rgba(19,33,71,0.12)', drawTicks: false },
              ticks: { min: 0, max: xMax, stepSize: 5, fontColor: 'rgba(51,58,68,0.4)', fontSize: 11, padding: 8, callback: (v: number) => {
                if (Math.abs(v - xMax) < 0.01) return v + '%';
                if (v % 5 === 0 && xMax - v >= 2.5) return v + '%';
                return '';
              } }
            }],
            yAxes: [{
              gridLines: { display: false },
              ticks: { fontColor: 'rgba(51,58,68,0.65)', fontSize: isMobileB ? 10 : 12, padding: isMobileB ? 6 : 12 }
            }]
          },
          tooltips: {
            backgroundColor: '#132147',
            titleFontColor: '#fff',
            bodyFontColor: 'rgba(255,255,255,0.9)',
            cornerRadius: 8,
            borderColor: 'rgba(255,255,255,0.08)',
            borderWidth: 1,
            callbacks: { label: (item: any) => ' ' + Number(item.xLabel).toFixed(1) + '%' }
          }
        }
      });
    }

    // §03 Investment Journey — horizontal waterfall bar chart
    const journeyCanvas = document.getElementById('journeyCanvas') as HTMLCanvasElement;
    if (journeyCanvas) {
      const ctxJ = journeyCanvas.getContext('2d');
      const jInitial  = Math.abs(this.graphInitialInvestmentInHomeCurrency);
      const jRent     = Math.max(this.RentalIncome, 0);
      const jCapGrowth = Math.max(this.capitalAppreciation, 0);
      const jFx       = Math.max(this.TotalReturnOfInvestment - this.capitalAppreciation - this.RentalIncome, 0);
      const jExit     = jInitial + jRent + jCapGrowth + jFx;
      const jMag  = Math.pow(10, Math.floor(Math.log10(jExit)));
      const jStep = jMag * 0.5;
      const jMax  = Math.ceil(jExit / jStep) * jStep;
      const selfJ = this;
      const isMobileJ = window.innerWidth < 600;
      const journeyLabels = isMobileJ
        ? ['Initial Inv.', 'Rental', 'Cap Growth', 'FX Gain', 'Exit Value']
        : ['Initial\nInvestment', 'Net Rental\nIncome', 'Capital\nGrowth', 'FX\nAppreciation', 'Value\nat Exit'];

      // Plugin: rounded corners on horizontal bars (Chart.js 2.x doesn't have borderRadius)
      const journeyRoundedPlugin = {
        afterDatasetsDraw(chart: any) {
          const ctx2 = chart.ctx;
          chart.data.datasets.forEach((dataset: any, dsIdx: number) => {
            const meta = chart.getDatasetMeta(dsIdx);
            meta.data.forEach((bar: any, barIdx: number) => {
              const vm = bar._view;
              if (!vm) return;
              const left  = Math.min(vm.x, vm.base);
              const w     = Math.abs(vm.x - vm.base);
              if (w < 2) return;
              const h = vm.height;
              const top = vm.y - h / 2;
              const bgColor = Array.isArray(dataset.backgroundColor)
                ? dataset.backgroundColor[barIdx]
                : dataset.backgroundColor;
              if (!bgColor || bgColor === 'rgba(0,0,0,0)') return;
              const r = Math.min(6, w / 2, h / 2);
              ctx2.save();
              // Erase the sharp bar with white then redraw rounded
              ctx2.fillStyle = '#ffffff';
              ctx2.fillRect(left, top, w, h);
              ctx2.fillStyle = bgColor;
              ctx2.beginPath();
              ctx2.moveTo(left + r, top);
              ctx2.lineTo(left + w - r, top);
              ctx2.quadraticCurveTo(left + w, top, left + w, top + r);
              ctx2.lineTo(left + w, top + h - r);
              ctx2.quadraticCurveTo(left + w, top + h, left + w - r, top + h);
              ctx2.lineTo(left + r, top + h);
              ctx2.quadraticCurveTo(left, top + h, left, top + h - r);
              ctx2.lineTo(left, top + r);
              ctx2.quadraticCurveTo(left, top, left + r, top);
              ctx2.closePath();
              ctx2.fill();
              ctx2.restore();
            });
          });
        }
      };

      new (Chart as any)(ctxJ, {
        type: 'horizontalBar',
        plugins: [journeyRoundedPlugin],
        data: {
          labels: journeyLabels,
          datasets: [
            {
              label: '_offset',
              data: [0, jInitial, jInitial + jRent, jInitial + jRent + jCapGrowth, 0],
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 0,
              hoverBackgroundColor: 'rgba(0,0,0,0)',
            },
            {
              label: 'Value',
              data: [jInitial, jRent, jCapGrowth, jFx, jExit],
              backgroundColor: ['#8a99b8', '#4a5a85', '#132147', '#132147', '#23B14B'],
              borderSkipped: false,
              barPercentage: 0.65,
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            xAxes: [{
              stacked: true,
              gridLines: { color: 'rgba(19,33,71,0.08)', zeroLineColor: 'rgba(19,33,71,0.12)', drawTicks: false },
              ticks: {
                min: 0, max: jMax, stepSize: jStep,
                fontColor: 'rgba(51,58,68,0.4)', fontSize: 10, padding: 8,
                callback: (v: number) => selfJ.formatCurrency(v, selfJ.homecurrencyText)
              }
            }],
            yAxes: [{
              stacked: true,
              gridLines: { display: false },
              ticks: { fontColor: 'rgba(51,58,68,0.6)', fontSize: isMobileJ ? 10 : 12, padding: isMobileJ ? 5 : 8 }
            }]
          },
          tooltips: {
            backgroundColor: '#132147',
            titleFontColor: '#fff',
            bodyFontColor: 'rgba(255,255,255,0.9)',
            cornerRadius: 8,
            borderColor: 'rgba(255,255,255,0.08)',
            borderWidth: 1,
            filter: (item: any) => item.datasetIndex === 1,
            callbacks: {
              title: (items: any[], data: any) => (data.labels[items[0].index] + '').replace('\n', ' '),
              label: (item: any) => ' ' + selfJ.formatCurrency(item.xLabel, selfJ.homecurrencyText)
            }
          }
        }
      });
    }

    if (!this.calcData.reportSavedOnServer && !this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
      this.reportSaveToServer();
    }

    window.addEventListener('resize', this._resizeHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this._resizeHandler);
    clearTimeout(this.resizeTimer);
  }

  ngOnInit(): void {
    this.loadAnnexureData();

    // Ensure all numeric fields are parsed as numbers
    this.calcData.PropertyValue = parseFloat(this.calcData.PropertyValue) || 0;
    this.calcData.capitalgrowth = parseFloat(this.calcData.capitalgrowth) || 0;
    this.calcData.fxgrowth = parseFloat(this.calcData.fxgrowth) || 0;
    this.calcData.rentalYeild = parseFloat(this.calcData.rentalYeild) || 0;
    this.calcData.rentalGrowthEscalation = parseFloat(this.calcData.rentalGrowthEscalation) || 0;
    this.calcData.letteingManagFee = parseFloat(this.calcData.letteingManagFee) || 0;
    this.calcData.stampDutyLandTax = parseFloat((this.calcData.stampDutyLandTax + '').replace(/,/g,'')) || 0;
    this.calcData.loanAmount = parseFloat(this.calcData.loanAmount) || 0;
    this.calcData.mortgageInterestRate = parseFloat(this.calcData.mortgageInterestRate) || 0;
    this.calcData.loanOriginationFee = parseFloat(this.calcData.loanOriginationFee) || 0;
    this.calcData.legalFees = parseFloat((this.calcData.legalFees + '').replace(/,/g,'')) || 0;
    this.calcData.groundRent = parseFloat((this.calcData.groundRent + '').replace(/,/g,'')) || 0;
    this.calcData.serviceCharges = parseFloat((this.calcData.serviceCharges + '').replace(/,/g,'')) || 0;
    this.calcData.miscelleneousExpense = parseFloat((this.calcData.miscelleneousExpense + '').replace(/,/g,'')) || 0;
    this.calcData.mortgageTenure = parseFloat(this.calcData.mortgageTenure) || this.investedTenure;
    this.calcData.homecurrency = parseFloat(this.calcData.homecurrency) || 1;
    this.homecurrency = this.calcData.homecurrency;
    this.Initialhomecurrency = this.calcData.homecurrency;

    // UK residents invest in GBP — no FX conversion or appreciation
    if (this.calcData.ForeignBuyer !== '1') {
      this.calcData.homecurrency = 1;
      this.calcData.fxgrowth = 0;
      this.homecurrency = 1;
      this.Initialhomecurrency = 1;
      this.homecurrencyText = 'GBP';
    }

    for (let i = 0; i < this.investedTenure; i++) {
      this.homecurrency = parseFloat((this.homecurrency + (this.homecurrency * (this.calcData.fxgrowth / 100))).toFixed(4));
      const data = { "PropertyValue": 0, "PropertyValueInHomeCurrency": 0, "GrossRent": 0, "LettingFee": 0, "CashFlow": 0, "CashFlowInHomeCurrency": 0, "GroundRent": 0, "ServiceCharges": 0, "MiscelleneousExpense": 0, "Interest": 0, "loanOutstanding": 0, "EMI": 0, "PrincipleRepayment": 0, "loanOutstandingInHomeCurrency": 0 };
      let PropertyValue: number;
      if (i == 0)
        PropertyValue = parseFloat(this.calcData.PropertyValue);
      else
        PropertyValue = this.TenureWisePropertyData[i - 1].PropertyValue;

      data.PropertyValue = parseFloat((PropertyValue + (PropertyValue * (this.calcData.capitalgrowth / 100))).toFixed(4));

      data.PropertyValueInHomeCurrency = parseFloat((data.PropertyValue * this.homecurrency).toFixed(4));
      if (i == 0)
        data.GrossRent = parseFloat((this.calcData.PropertyValue * (this.calcData.rentalYeild / 100)).toFixed(4));
      else
        data.GrossRent = parseFloat((this.TenureWisePropertyData[i - 1].GrossRent + (this.TenureWisePropertyData[i - 1].GrossRent * (this.calcData.rentalGrowthEscalation / 100))).toFixed(4));

      data.LettingFee = parseFloat((data.GrossRent * (this.calcData.letteingManagFee / 100)).toFixed(4));
      if (this.calcData.optmortgage == "1") {
        if (this.calcData.mortgageType == "1") {
          data.Interest = (this.calcData.PropertyValue * (this.calcData.loanAmount / 100)) * (this.calcData.mortgageInterestRate / 100);
          data.loanOutstanding = (this.calcData.PropertyValue * (this.calcData.loanAmount / 100));
          data.loanOutstandingInHomeCurrency = parseFloat((data.loanOutstanding * this.calcData.homecurrency).toFixed(4));
        } else {
          const P = this.calcData.PropertyValue * (this.calcData.loanAmount / 100);
          const R = ((this.calcData.mortgageInterestRate / 100) / 12);
          const N = this.calcData.mortgageTenure * 12;
          data.EMI = parseFloat(((P * R * Math.pow(1 + R, N) / (Math.pow(1 + R, N) - 1)) * 12).toFixed(4));
          if (i == 0) {
            data.Interest = (this.calcData.PropertyValue * (this.calcData.loanAmount / 100)) * (this.calcData.mortgageInterestRate / 100);
            data.PrincipleRepayment = data.EMI - data.Interest;
            data.loanOutstanding = P - data.PrincipleRepayment;
            data.loanOutstandingInHomeCurrency = parseFloat((data.loanOutstanding * this.calcData.homecurrency).toFixed(4));
          } else {
            data.Interest = this.TenureWisePropertyData[i - 1].loanOutstanding * (this.calcData.mortgageInterestRate / 100);
            data.PrincipleRepayment = data.EMI - data.Interest;
            data.loanOutstanding = this.TenureWisePropertyData[i - 1].loanOutstanding - data.PrincipleRepayment;
            data.loanOutstandingInHomeCurrency = parseFloat((data.loanOutstanding * this.calcData.homecurrency).toFixed(4));
          }
        }
      }
      data.GroundRent = this.calcData.groundRent || 0;
      data.ServiceCharges = this.calcData.serviceCharges || 0;
      data.MiscelleneousExpense = this.calcData.miscelleneousExpense || 0;

      // if(this.calcData.optmortgage == "1"){
      //   data.CashFlow = parseInt((data.GrossRent - data.LettingFee).toFixed()) - data.GroundRent - data.ServiceCharges - data.MiscelleneousExpense - data.Interest - data.PrincipleRepayment;
      // }else{
      //   data.CashFlow = parseInt((data.GrossRent+ data.EMI- data.LettingFee).toFixed()) - data.GroundRent - data.ServiceCharges - data.MiscelleneousExpense - data.Interest - data.PrincipleRepayment;
      // }
      data.CashFlow = data.GrossRent - data.LettingFee - data.GroundRent - data.ServiceCharges - data.MiscelleneousExpense - data.Interest - data.PrincipleRepayment;
      this.RentalIncome = this.RentalIncome + (data.GrossRent - data.GroundRent - data.LettingFee - data.ServiceCharges - data.MiscelleneousExpense - data.Interest - data.PrincipleRepayment);
      data.CashFlowInHomeCurrency = parseFloat((data.CashFlow * this.homecurrency).toFixed(4));
      this.yearlyPropertyValueInGBP.push(((data.PropertyValue - this.calcData.PropertyValue) / this.calcData.PropertyValue) * 100);
      this.yearlyPropertyValueInHomeCurrency.push(((data.PropertyValueInHomeCurrency - (this.calcData.PropertyValue * this.calcData.homecurrency)) / (this.calcData.PropertyValue * this.calcData.homecurrency)) * 100);
      this.TenureWisePropertyData.push(data);
      if (i == this.investedTenure - 1) {
        this.EquityCapital = parseFloat(((data.PropertyValue - data.loanOutstanding)).toFixed(4));
        this.allCahsflow.push(parseFloat((data.CashFlow + data.PropertyValue - data.loanOutstanding).toFixed(4)));
        this.allCashFlowInHomeCurrency.push(parseFloat((data.CashFlowInHomeCurrency + (data.PropertyValue * this.homecurrency) - (data.loanOutstanding * this.homecurrency)).toFixed(4)));
      } else {
        this.allCahsflow.push(data.CashFlow);
        this.allCashFlowInHomeCurrency.push(data.CashFlowInHomeCurrency);
      }
    }
    this.RentalIncome = parseInt((this.RentalIncome * this.Initialhomecurrency).toFixed(4));
    
    let InitialInvesment = 0;
    if (this.calcData.optmortgage == "0") {
      InitialInvesment = 0 - parseFloat((parseFloat(this.calcData.PropertyValue) + parseFloat(this.calcData.stampDutyLandTax)).toFixed(4));
    } else {
      InitialInvesment = 0 - parseFloat(((this.calcData.PropertyValue * ((100 - this.calcData.loanAmount) / 100)) + parseFloat(this.calcData.stampDutyLandTax) + (this.calcData.PropertyValue * ((this.calcData.loanAmount) / 100)) * (this.calcData.loanOriginationFee / 100)).toFixed(4));
    }
    this.allCahsflow.splice(0, 0, InitialInvesment);
    try { this.IrrInGBP = finance.IRR.apply(this, this.allCahsflow); } catch (e) { this.IrrInGBP = 0; }
    let InitialInvesmentInHomeCurrency = parseFloat((InitialInvesment * this.calcData.homecurrency).toFixed(4));
    this.allCashFlowInHomeCurrency.splice(0, 0, InitialInvesmentInHomeCurrency);
    try { this.IrrInHomeCurrency = finance.IRR.apply(this, this.allCashFlowInHomeCurrency); } catch (e) { this.IrrInHomeCurrency = 0; }
    this.capitalAppreciation = parseFloat(((this.EquityCapital+ InitialInvesment)*this.calcData.homecurrency).toFixed(4));
    this.graphInitialInvestmentInHomeCurrency = InitialInvesmentInHomeCurrency;
    //console.log(this.allCashFlowInHomeCurrency);
    this.TotalReturnOfInvestment = parseFloat((this.allCashFlowInHomeCurrency.reduce((a, b) => a + b, 0)).toFixed(4));
    this.fxAppreciation = Math.max(this.TotalReturnOfInvestment - this.RentalIncome - this.capitalAppreciation, 0);
    // GBP equivalents (no FX component in GBP)
    this.RentalIncomeGBP = parseFloat((this.RentalIncome / this.Initialhomecurrency).toFixed(4));
    this.capitalAppreciationGBP = parseFloat((this.EquityCapital + InitialInvesment).toFixed(4));
    this.TotalReturnInGBP = parseFloat((this.RentalIncomeGBP + this.capitalAppreciationGBP).toFixed(4));// Math.abs(parseFloat((this.allCashFlowInHomeCurrency.reduce((a, b) => a + b, 0)).toFixed(4)));
   // console.log(this.TotalReturnOfInvestment);
    const absInitialHC = Math.abs(InitialInvesmentInHomeCurrency);
    this.wealthMultiple = absInitialHC > 0 ? parseFloat(((absInitialHC + this.TotalReturnOfInvestment) / absInitialHC).toFixed(2)) : 0;
    this.returnOnEquity = absInitialHC > 0 ? parseFloat((this.TotalReturnOfInvestment / absInitialHC * 100).toFixed(2)) : 0;
    this.benchMax = Math.max(this.IrrInHomeCurrency || 0, this.IrrInGBP || 0, 20);
   for (let k = 0; k < this.TenureWisePropertyData.length; k++) {
      this.yearlabel.push('Yr ' + (k + 1));
      let TempyearlyGBPIRR = 0;
      let TempyearlyHomeCurrencyIRR = 0;
      if (k >= 1) {
        try {
          TempyearlyGBPIRR = parseFloat(this.ReturnIRR(InitialInvesment, k).toFixed(2));
          TempyearlyHomeCurrencyIRR = parseFloat(this.ReturnIRRInHomeCurrency(InitialInvesmentInHomeCurrency, k).toFixed(2));
        } catch (error) {
          TempyearlyGBPIRR = 0;
          TempyearlyHomeCurrencyIRR = 0;
        }
      }
      this.yearlyGBPIRR.push(isFinite(TempyearlyGBPIRR) ? TempyearlyGBPIRR : 0);
      this.yearlyHomeCurrencyIRR.push(isFinite(TempyearlyHomeCurrencyIRR) ? TempyearlyHomeCurrencyIRR : 0);
    }
    // Replace final year with the actual overall IRR
    if (this.yearlabel.length > 0) {
      this.yearlyGBPIRR[this.yearlyGBPIRR.length - 1] = parseFloat((this.IrrInGBP || 0).toFixed(2));
      this.yearlyHomeCurrencyIRR[this.yearlyHomeCurrencyIRR.length - 1] = parseFloat((this.IrrInHomeCurrency || 0).toFixed(2));
    }
  }

  private loadAnnexureData(): void {
    const cityKey = this.resolveAnnexureCityKey(this.calcData?.City);
    this.http.get<CityAnnexureDataMap>('assets/annexure-market-data.json').subscribe(
      (data) => {
        this.annexureData = data?.[cityKey] || data?.Manchester || this.getDefaultAnnexureData();
      },
      () => {
        this.annexureData = this.getDefaultAnnexureData();
      }
    );
  }

  private getDefaultAnnexureData(): CityAnnexureData {
    return {
      executiveStats: [],
      executiveParagraphs: [],
      boeRows: [],
      boeNote: '',
      mortgageRows: [],
      mortgageNote: '',
      outlookTitle: '',
      outlookSub: '',
      outlookCards: [],
      financialNewsSub: '',
      financialNewsLeft: [],
      financialNewsRight: [],
      comparablesSub: '',
      comparables: []
    };
  }
  

  makePositive(value){
    return Math.abs(value);
  }

  getJourneyInitialInvestment(): number {
    return Math.abs(this.graphInitialInvestmentInHomeCurrency || 0);
  }

  getJourneyNetRental(): number {
    return Math.max(this.RentalIncome || 0, 0);
  }

  getJourneyCapitalGrowth(): number {
    return Math.max(this.capitalAppreciation || 0, 0);
  }

  getJourneyFxAppreciation(): number {
    return Math.max((this.TotalReturnOfInvestment || 0) - (this.capitalAppreciation || 0) - (this.RentalIncome || 0), 0);
  }

  getJourneyTotalProfit(): number {
    return Math.max(this.TotalReturnOfInvestment || 0, 0);
  }

  getJourneyValueAtExit(): number {
    return Math.max((this.TotalReturnOfInvestment || 0) - (this.graphInitialInvestmentInHomeCurrency || 0), 0);
  }

  getJourneyMax(): number {
    return Math.max(
      this.getJourneyInitialInvestment(),
      this.getJourneyNetRental(),
      this.getJourneyCapitalGrowth(),
      this.getJourneyFxAppreciation(),
      this.getJourneyTotalProfit(),
      this.getJourneyValueAtExit(),
      1
    );
  }

  getJourneyFlex(value: number): string {
    const max = this.getJourneyMax();
    const normalized = Math.max(value / max, 0.06);
    return normalized.toFixed(3);
  }

  ReturnIRR(InitialInvestMent: number, index: number): number {
    let cashFlow = [];
    for (let i = 0; i <= index; i++) {
      if (i == index) {
        cashFlow.push(parseFloat((this.TenureWisePropertyData[i].PropertyValue - this.TenureWisePropertyData[i].loanOutstanding + this.TenureWisePropertyData[i].CashFlow).toFixed(4)))
      } else {
        cashFlow.push(this.TenureWisePropertyData[i].CashFlow)
      }
    }
    cashFlow.splice(0, 0, InitialInvestMent);
    try { return finance.IRR.apply(this, cashFlow); } catch (e) { return 0; }
  }
  ReturnIRRInHomeCurrency(InitialInvestMent: number, index: number): number {
    let cashFlow = [];
    let HomeCurrency = parseFloat(parseFloat(this.calcData.homecurrency).toFixed(4));
    for (let i = 0; i <= index; i++) {
      HomeCurrency = HomeCurrency + (HomeCurrency * (this.calcData.fxgrowth / 100));
      if (i == index) {
        let LastCashFlowGbp = parseFloat((this.TenureWisePropertyData[i].PropertyValue - this.TenureWisePropertyData[i].loanOutstanding + this.TenureWisePropertyData[i].CashFlow).toFixed(4));
        cashFlow.push(parseFloat((LastCashFlowGbp * HomeCurrency).toFixed(4)));
      } else {
        cashFlow.push(this.TenureWisePropertyData[i].CashFlowInHomeCurrency)
      }
    }
    cashFlow.splice(0, 0, InitialInvestMent);
    try { return finance.IRR.apply(this, cashFlow); } catch (e) { return 0; }
  }
  selectCountry(country: string): void {
    this.selectedCountry = country;
    const fx = this.countryFxMap[country];
    if (!fx || !this.irrChart) return;

    const fxRate = fx.rate;
    const fxGrowth = fx.fxGrowth;
    const tenure = this.investedTenure;

    // Recompute InitialInvestment in this country's currency
    let InitialInvesment = 0;
    if (this.calcData.optmortgage == "0") {
      InitialInvesment = 0 - (parseFloat(this.calcData.PropertyValue) + parseFloat(this.calcData.stampDutyLandTax));
    } else {
      InitialInvesment = 0 - ((this.calcData.PropertyValue * ((100 - this.calcData.loanAmount) / 100))
        + parseFloat(this.calcData.stampDutyLandTax)
        + (this.calcData.PropertyValue * (this.calcData.loanAmount / 100)) * (this.calcData.loanOriginationFee / 100));
    }
    const InitialInHC = InitialInvesment * fxRate;

    // Recompute yearly HC IRR using this country's FX rate + growth
    const newYearlyHCIRR: number[] = [];
    let currentFx = fxRate;
    for (let k = 0; k < tenure; k++) {
      currentFx = currentFx + (currentFx * (fxGrowth / 100));
      if (k === 0) {
        newYearlyHCIRR.push(0);
        continue;
      }
      try {
        let cf: number[] = [InitialInHC];
        let fx2 = fxRate;
        for (let i = 0; i <= k; i++) {
          fx2 = fx2 + (fx2 * (fxGrowth / 100));
          if (i === k) {
            const lastGbp = this.TenureWisePropertyData[i].PropertyValue
              - this.TenureWisePropertyData[i].loanOutstanding
              + this.TenureWisePropertyData[i].CashFlow;
            cf.push(parseFloat((lastGbp * fx2).toFixed(4)));
          } else {
            cf.push(parseFloat((this.TenureWisePropertyData[i].CashFlow * fx2).toFixed(4)));
          }
        }
        const irr = parseFloat(finance.IRR.apply(this, cf).toFixed(2));
        newYearlyHCIRR.push(isFinite(irr) ? irr : 0);
      } catch {
        newYearlyHCIRR.push(0);
      }
    }

    // Update chart dataset 1 (home currency IRR line)
    this.irrChart.data.datasets[1].data = newYearlyHCIRR;
    this.irrChart.data.datasets[1].label = fx.currency + ' IRR';
    this.irrChart.update();
  }

  startagain(): void {
    localStorage.removeItem('calcData');
    this.router.navigate(['/']);
  }

  printScreen() {
    if (!this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
      this.loadingPrintbtn = true;
      window.print();
      this.loadingPrintbtn = false;
    }
    else {
      this.router.navigateByUrl('/login?ref=/calculated-irr');
    }
  }

  convetToPDF() {
    if (!this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
      this.loadingDownloadbtn = true;
      $(".noprint").addClass("displaynone");
      const data = document.getElementById('contentToConvert');
      html2canvas(data,
        {
          scrollY: -window.scrollY,
          logging: true,
          useCORS: true,
          allowTaint: true
        }).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          var position = 0;
          pdf.addImage(contentDataURL, 'PNG', 20, 5, pdf.internal.pageSize.getWidth() - 40, pdf.internal.pageSize.getHeight() - 20)
          pdf.save('new-file.pdf'); // Generated PDF
          this.loadingDownloadbtn = false;
        });
      $(".noprint").removeClass("displaynone");

    }
    else {
      this.router.navigateByUrl('/login?ref=/calculated-irr');
    }
  }

  shareReport(email: string) {
    if (this.dataService.EmptyNullOrUndefined(email)){
          alert('Email is mandatory to share IRR Result');
      }
    else{
      var multipleUser = email.split(',');
      if(multipleUser.length > 5){
          alert('You cannot share report to more than 5 recipients at a time.')
        }
      else{
          var obj = {};
          var errorresult = "";
          for(var i = 0; i<multipleUser.length;i++){
            if(obj[multipleUser[i]] === undefined ){
               obj[multipleUser[i]] = 1;
            }
            else{
                  errorresult+=multipleUser[i];
                  if(i<multipleUser.length-1)
                  errorresult+=",";
            }
          }
          if(errorresult!==""){
          alert(errorresult + " is repeated");
          }
          else{
      if (!this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
        this.loadingSharebtn = true;
        $(".noprint").addClass("displaynone");
         const data = document.getElementById('contentToConvert');
        html2canvas(data,
          {
            scrollY: -window.scrollY,
            logging: true,
            useCORS: true,
            allowTaint: true
          }).then(canvas => {
            let contentDataURL = canvas.toDataURL('image/png');
            contentDataURL = contentDataURL.replace("data:image/png;base64,", "");
            const Data = { "UserId": sessionStorage.getItem('UserId'), "EmailId": email, "ResultImageBase64String": contentDataURL,"CalculatorId" :localStorage.getItem('CalculatorText') };
            const Response = this.dataService.PostAdventumRequest('v1/sendresultonmail', Data).subscribe((response) => {
              if (response.n === 1) {
                alert(response.Msg);
                $("#rptShareModal").modal("hide");
              } else if (response.n === 0) {
                alert(response.Msg);
              } else {
                alert('Something went wrong please try agian later');
              }
              this.loadingSharebtn = false;
            });
          });
           $(".noprint").removeClass("displaynone");
      }
      else {
        $("#rptShareModal").modal("hide");
        this.router.navigateByUrl('/login?ref=/calculated-irr');
      }
    }
      }
    }
  }
  reportSaveToServer() {
    setTimeout(() => {
      if (!this.calcData.reportSavedOnServer && !this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
        $(".noprint").addClass("displaynone");
        const data = document.getElementById('contentToConvert');
        html2canvas(data,
          {
            scrollY: -window.scrollY,
            logging: true,
            useCORS: true,
            allowTaint: true
          }).then(canvas => {
            let contentDataURL = canvas.toDataURL('image/png');
            contentDataURL = contentDataURL.replace("data:image/png;base64,", "");
            const Data = { "UserId": sessionStorage.getItem('UserId'), "CalculatorId": localStorage.getItem('CalculatorType').toString(), "ResultImageBase64String": contentDataURL };
            const Response = this.dataService.PostAdventumRequest('v1/saveuserresult', Data).subscribe((response) => {
              this.calcData.reportSavedOnServer = true;
              localStorage.setItem("calcData", JSON.stringify(this.calcData));
            });
          });
        $(".noprint").removeClass("displaynone");
      }
    }, 5000);

  }
}
